import JSZip from "jszip";
import { saveAs } from "file-saver"; // Install with `npm install file-saver`

const downloadCoChampImages = async (cochamp) => {
  const zip = new JSZip();
  const imgfiles = [];
  let general_name = cochamp.name.replace(" ", "_");

  // Collect image files to add to the zip
  cochamp.champs.forEach((champ) => {
    if (champ.type === "img" && champ.content?.length > 0) {
      for (let i = 0; i < champ.content.length; i++) {
        imgfiles.push({
          url: champ.content[i],
          name:
            champ.name.replace(/[^a-zA-Z0-9._-]/g, "_").replace(/_{2,}/g, "_") +
            "_" +
            i +
            ".jpg",
        });
      }
    } else if (champ.type === "imgtext" && champ.content?.length > 0) {
      imgfiles.push({
        url: champ.content[1],
        name:
          champ.name.replace(/[^a-zA-Z0-9._-]/g, "_").replace(/_{2,}/g, "_") +
          ".jpg",
      });
    }
  });

  // Fetch each image and add it to the zip
  for (const imgfile of imgfiles) {
    const { url, name } = imgfile;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch ${name}: ${response.statusText}`);
      }
      let index = imgfiles.indexOf(imgfile);

      const blob = await response.blob();
      zip.file(`${name}`, blob); // Add the fetched blob to the zip
    } catch (error) {
      console.error(`Error adding ${name} to zip:`, error.message);
    }
  }

  // Generate the zip file and trigger download
  zip.generateAsync({ type: "blob" }).then((content) => {
    saveAs(
      content,
      `${cochamp.name.replace(/[^a-zA-Z0-9._-]/g, "_").replace(/_{2,}/g, "_")}_images_controle.zip`
    ); // Prompt user to download zip file
  });
};

export default downloadCoChampImages;
